import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Alert, Button, Grid, Link, Paper, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateCalifornia = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="California Business Tax filing requirements | TaxZerone"
          description="Learn about California business tax filing requirements with TaxZerone. Get guidance to meet deadlines and stay compliant with California tax laws."
          keywords=" "
          canonical="business-tax/state-filing/california-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/california-business-tax-img.webp" />
                <source srcSet="/assets/images/california-business-tax-img.png" />
                <img
                  src="/assets/images/california-business-tax-img.png"
                  alt="California Business Tax Requirements — File smarter, Stay Compliant"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">California </span>
                </span>{' '}
                Business Tax Requirements — File smarter, Stay Compliant
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Understand what your business needs to file in California. From
                corporate income taxes to LLC filings and extensions, stay on
                top of every requirement and deadline to avoid penalties.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/california-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/california-business-tax-img-sm.png" />
                <img
                  src="/assets/images/california-business-tax-img-sm.png"
                  alt="California Business Tax Requirements — File smarter, Stay Compliant"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in California?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
            California requires different business entities to file specific
            state tax forms with the{' '}
            <span style={{ fontWeight: 600 }}> Franchise Tax Board (FTB)</span>.
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            Here’s a breakdown by business type:
          </Typography>

          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br /> Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-pdf/f1040.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Federal Form 1040
                        </Link>{' '}
                        –
                      </span>{' '}
                      Individual Income Tax Return
                    </li>

                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-540.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 540
                        </Link>{' '}
                        -
                      </span>{' '}
                      California Resident Income Tax Return
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-540nr.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 540-NR
                        </Link>{' '}
                        -
                      </span>{' '}
                      California Non-Resident or Part-Year Resident Income Tax
                      Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-565.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 565
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Partnership Return of Income
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-565.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 568
                        </Link>{' '}
                        –
                      </span>{' '}
                      Limited Liability Company Return of Income
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2025/2025-3522.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          FTB 3522
                        </Link>{' '}
                        –
                      </span>{' '}
                      LLC Tax Voucher
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2025/2025-3536.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          FTB 3536
                        </Link>{' '}
                        –
                      </span>{' '}
                      Estimated Fee for LLC
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-100.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 100
                        </Link>{' '}
                        –
                      </span>{' '}
                      California Corporation Franchise or Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-100-es.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 100-ES
                        </Link>{' '}
                      </span>{' '}
                      Corporation Estimated Tax
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-100w.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 100W
                        </Link>{' '}
                        -
                      </span>{' '}
                      California Corporation Franchise or Income Tax
                      Return-Water&apos;s –Edge Filers
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="S Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2023/2023-100s.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 100S
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      California S Corporation or Income Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Pass-Through Entities"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Pass-Through Entities
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2025/2025-3893.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form 3893
                        </Link>{' '}
                        –
                      </span>{' '}
                      Pass- Through Entity Elective Tax Payment Voucher
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-3804.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 3804
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Pass- Through Entity Elective Tax Calculation
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-3804-cr.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 3804-CR
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Pass-Through Entity Elective Tax Credit
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/withholding-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/withholding-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/withholding-tax-icon.png"
                    alt="Tax-Exempt Organizations"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Tax-Exempt Organizations
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-199.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 199
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      California Exempt Organization Annual Information Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="http://ftb.ca.gov/forms/2022/2022-109.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 109
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      California Exempt Organization Business Income Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Additional California Business Tax Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Additional California Business Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-3872.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 3872
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      California Disaster Relief Request for Postponement of Tax
                      Deadlines
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2023/2023-100-h.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH H (100)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Dividend Income Deduction
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-100s-h.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH H(100S)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Dividend Income Deduction
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2023/2023-100s-k-1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Schedule K-1(100S)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Shareholder’s Share of Income, Deductions, Credits, etc.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2022/2022-100s-b.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH B (100S)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Depreciation and Amortization
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2022/2022-100s-c.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH C (100S)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Tax Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2022/2022-100s-d.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH D (100S)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Capital Gains and Losses and Built-In Gains
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-541-d.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH D (541)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Capital Gain or Loss
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-540-s.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH S
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Other State Tax Credits
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-565-k-1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH K-1 (565)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Partner’s Share of Income, Deduction, Credits, etc.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-568-k-1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH K-1 (568)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Member’s Share of Income, Deduction, Credits, etc.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-568-k-1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SSCH H (100W)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Dividend Income Deduction- Water&apos;s Edge Filers
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2024/2024-565-eo.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH EO (565)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Pass- Through Entity Ownership
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.ftb.ca.gov/forms/2022/2022-568-eo.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCH EO (568)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Pass-Through Entity Ownership
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 2 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the deadlines for the Business Tax Forms in California?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Understand the key deadlines for filing California business
                taxes for all entity types:
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                General Partnerships
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15th day
                </Box>
                <br />
                of 3<sup>rd</sup> month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(213, 189, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Stack
                spacing={2}
                direction={{ md: 'column', xs: 'column' }}
                justifyContent="center"
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Limited Partnerships / LLPs / LLLPs
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 18, md: 16, sm: 14, xs: 14 },
                        fontWeight: 500,
                      }}
                    >
                      Return due date:{' '}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          background:
                            'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                          backgroundClip: 'text',
                          color: 'transparent',
                          fontWeight: 700,
                          fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                        }}
                      >
                        15<sup>th</sup> day
                      </Box>{' '}
                      <br />
                      of 3<sup>rd</sup> month
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Limited Liability Companies (LLCs)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>
                <br />
                of 3<sup>rd</sup> month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                S Corporations <br />
                (Form 100S)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Return due date:{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>{' '}
                of 3rd month
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Payment due date:{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>{' '}
                of 3rd month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                C Corporations <br /> (Form 100 / 100W)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Return due date:{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>{' '}
                of 3rd month
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                Payment due date:{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 28, md: 26, sm: 22, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>{' '}
                of 3rd month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 2,
                borderRadius: 4,
                minHeight: '100%',
                justifyContent: 'center',
                alignContent: 'center',
                background:
                  'linear-gradient(274deg,rgba(255, 247, 254, 1) 0%, rgba(189, 246, 255, 1) 100%)',
              }}
              // className="bg-pattern"
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Exempt Organizations (Form 199 / 109)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 500,
                  textAlign: 'center',
                }}
              >
                Return due date:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontWeight: 700,
                    fontSize: { lg: 48, md: 40, sm: 38, xs: 20 },
                    background:
                      'linear-gradient(63deg,rgba(69, 36, 124, 1) 0%, rgba(95, 58, 177, 1) 47%, rgba(145, 115, 200, 1) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  15<sup>th</sup> day
                </Box>
                <br />
                of 5<sup>th</sup> month
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Alert
              severity="info"
              id="who"
              icon={false}
              sx={{ mb: 4, borderLeft: '3px solid #0288d1', textAlign: 'left' }}
            >
              <span style={{ fontWeight: 600 }}> Important Reminder:</span>
              <br /> An extension gives you{' '}
              <span style={{ fontWeight: 600 }}>
                extra time to file, not to pay.
              </span>{' '}
              All taxes owed must be paid by the original due date to avoid
              penalties and interest.
            </Alert>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Business Extension Forms are required in California?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Business Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    ml: -3,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Corporation & Exempt Organizations{' '}
                      <Link
                        href="https://www.ftb.ca.gov/forms/2024/2024-3539.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form FTB 3539
                      </Link>
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Limited Liability Companies (LLCs){' '}
                      <Link
                        href="https://www.ftb.ca.gov/forms/2024/2024-3537.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form FTB 3537
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Limited Partnerships, LLPs, or REMICs{' '}
                      <Link
                        href="https://www.ftb.ca.gov/forms/2024/2024-3538.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form FTB 3538{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                </Box>
                <Box
                  sx={{
                    maxWidth: 350,
                    mb: 3,
                    p: 2,
                    border: '5px solid transparent',
                    borderRadius: 3,
                    background:
                      'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 700, mb: 0.8 }}>
                    {' '}
                    <MailOutlineOutlinedIcon
                      sx={{
                        position: 'relative',
                        ml: 0,
                        mr: 0.5,
                        mb: -1,
                        fontSize: 28,
                      }}
                    />{' '}
                    Mail Form FTB 3539, FTB 3537, FTB 3538 of the following
                    address:
                  </Typography>
                  <Box
                    component="div"
                    sx={{ textAlign: 'left', fontSize: '15px important' }}
                  >
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Franchise Tax Board
                      </span>{' '}
                      <br />
                      PO Box 942857 <br />
                      Sacramento, CA 94257-0531
                    </Typography>
                  </Box>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  California Business tax payments can also be made (no
                  registration required) at:{' '}
                  <Link
                    href="https://www.ftb.ca.gov/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Webpay for Businesses
                  </Link>
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> TaxZerone supports{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 7004
                  </Link>{' '}
                  for federal business tax extensions and provides guidance for
                  California state extension forms (FTB 3539, 3537, and 3538)
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/california-payment-form-img.webp" />
                  <source srcSet="/assets/images/california-payment-form-img.png" />
                  <img
                    src="/assets/images/california-payment-form-img.png"
                    alt="What Business Extension Forms are required in California?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due dates for Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Forms in California?
              </Typography>
              {/* <Typography variant="body1" sx={{ mb: 3, fontSize: 18 }}>
                Understand the key{' '}
                <span style={{ fontWeight: 600 }}> extended deadlines</span> for
                filing Connecticut business taxes for all entity types:
              </Typography> */}
              <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      General Partnerships
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 3,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Limited Partnerships / LLPs / LLLPs
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Limited Liability Companies (LLCs)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      S Corporations (Form 100S)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 9<sup>th</sup> month
                    </Typography>
                  </Paper>{' '}
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      C Corporations <br /> (Form 100 / 100W)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ mb: 0, textAlign: 'left', '& li': { mb: 1.2 } }}
                    >
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Tax year 2018 & prior:
                        </span>{' '}
                        15th day of 10th month{' '}
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Tax year 2019 & later:
                        </span>{' '}
                        15th day of 11th month{' '}
                      </li>
                    </Box>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Exempt Organizations (Form 199 / 109)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 11<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
              </Box>
              <Alert
                severity="warning"
                icon={false}
                sx={{ mb: 0, mt: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
              >
                <b>Note: </b> If the due date falls on a Saturday, Sunday, or
                legal holiday, the return is considered timely if filed on the
                next business day.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  California Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in California, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          File or pay by the original due date
                        </span>{' '}
                        to avoid late penalties.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Submit the correct extension form
                        </span>{' '}
                        based on your entity type (Form 3537, 3538, or 3539).
                      </Box>{' '}
                    </li>

                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Estimate and pay any taxes owed -
                        </span>{' '}
                        extensions only apply to filing, not to payments.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Meet the 6-month filing window,
                        </span>{' '}
                        typically extending your deadline to{' '}
                        <span style={{ fontWeight: 600 }}> October 15</span>.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Keep records and confirmations
                        </span>{' '}
                        from the Franchise Tax Board (FTB) for compliance.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{}}>
                  <picture>
                    <source
                      srcSet="/assets/images/california-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/california-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/california-state-img.png"
                      loading="lazy"
                      alt="business tax extension in  California"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 1,
                    }}
                  >
                    California Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 1,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates vary depending on your entity type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    8.84%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of net income
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    1.5%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of net income
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    LLCs
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    $800
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    minimum annual franchise tax plus LLC fee ($900–$11,790
                    based on income).
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Partnerships (LP & LLPs)
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    $800
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    minimum annual tax
                  </Typography>
                </Paper>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Exempt Organizations
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Generally, exempt but may pay on unrelated business income
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated Tax Payments for California Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 19, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses in California must make{' '}
                  <span style={{ fontWeight: 600 }}>
                    estimated tax payments
                  </span>{' '}
                  if they expect to owe{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  <span style={{ fontWeight: 600 }}>
                    $500 or more in state income tax{' '}
                  </span>{' '}
                  for the year. These prepayments help you avoid underpayment of
                  penalties.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      April 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      June 15
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Sept 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Dec 15
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Corporation & S Corps
                    </Typography>
                    <Typography variant="body1">
                      If expected tax &gt; $500
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      LLCs
                    </Typography>
                    <Typography variant="body1">
                      Based on total income and applicable LLC fees.
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Sole Proprietors & Partnerships
                    </Typography>
                    <Typography variant="body1">
                      Pay using{' '}
                      <span style={{ fontWeight: 600 }}> Form 540-ES. </span>
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Late or missed estimated payments may lead to{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    interest and penalties
                  </span>
                  .{' '}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Business in California
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                If your business doesn’t pay the required tax by the original
                due date,
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  penalties and interest
                </span>{' '}
                may apply—even if you’ve filed an extension.
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 0 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Payment Penalty
                    </Typography>
                    <Typography variant="body1">
                      5% of the unpaid tax{' '}
                      <span style={{ fontWeight: 600 }}>
                        plus 0.5% for each month
                      </span>{' '}
                      (or part of a month) the payment is late, up to a maximum
                      of <span style={{ fontWeight: 600 }}> 25%</span>
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Filing Penalty
                    </Typography>
                    <Typography variant="body1">
                      5% of the unpaid tax{' '}
                      <span style={{ fontWeight: 600 }}>
                        plus 5% for each additional month
                      </span>{' '}
                      (or part of a month), up to{' '}
                      <span style={{ fontWeight: 600 }}>25%</span> of the unpaid
                      amount.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '100%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Interest
                    </Typography>
                    <Typography variant="body1">
                      Charged daily on any unpaid balance until it’s fully paid.
                      The rate is adjusted{' '}
                      <span style={{ fontWeight: 600 }}>quarterly</span> and
                      follows the{' '}
                      <span style={{ fontWeight: 600 }}>
                        California FTB interest rate.
                      </span>
                    </Typography>
                  </Paper>
                </Box>
              </Stack>

              <Alert
                severity="info"
                icon={false}
                sx={{ mb: 3, mt: 3, borderLeft: '3px solid #0288d1' }}
              >
                <b>Tips:</b> Filing your extension and making a timely payment
                through TaxZerone helps you avoid costly penalties and interest.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2, mb: 0 }}>
                  TaxZerone makes tax filing simple and secure by supporting
                  federal filings and guiding you through state requirements,
                  ensuring accuracy, compliance, and confidence whether you’re
                  filing for your business or yourself.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Stay on top of California business tax filing requirements
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          learn what forms your business needs, important deadlines, and how
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>
          TaxZerone helps you stay informed and compliant.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=california`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What forms does my business need to file in California
                  State?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      The specific forms your California business needs to file
                      depend on its legal structure. Below is a breakdown of the
                      common filings required for each business type:
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      For Corporations{' '}
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}> Form 100:</span>{' '}
                        California Corporation Franchise or Income Tax
                        Return{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}> Form 100S:</span>{' '}
                        California S Corporation Franchise or Income Tax Return
                        (for S-corps)
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Annual Report:
                        </span>{' '}
                        Must be filed with the California Secretary of
                        State{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}> Form K-1:</span>{' '}
                        Issued to shareholders to report their share of income,
                        deductions, and credits
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      For LLCs (Limited Liability Companies)
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}> Form 568:</span> LLC
                        Return of Income
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}> Schedule K-1:</span>{' '}
                        For members to report income and losses
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>LLC Fee:</span> Based
                        on total income (if applicable)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Minimum Franchise Tax:
                        </span>{' '}
                        An{' '}
                        <span style={{ fontWeight: 600 }}>
                          annual $800 tax
                        </span>{' '}
                        may apply even if the LLC is not actively conducting
                        business
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      For Sole Proprietorships
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Schedule C (Form 1040):
                        </span>{' '}
                        Profit or Loss from Business (Sole Proprietorship)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}> Form 1040:</span>{' '}
                        Primary California tax form for residents
                      </li>
                      <li>
                        {' '}
                        <span style={{ fontWeight: 600 }}>
                          Form 540NR:
                        </span>{' '}
                        Used by non-residents or part-year residents
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Does California automatically grant extensions for
                  businesses?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1 }}>
                      Yes. Most business entities automatically receive an
                      extension to file. However, payment is still due by the
                      original return due date.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How do I get an extension of time to file in California?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      The FTB automatically gives you extra time to file your
                      return, but this extension does{' '}
                      <span style={{ fontWeight: 600 }}> not</span> apply to tax
                      payments. You must pay any estimated taxes by the original
                      due date to avoid penalties and interest.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What happens if I don’t pay my taxes by the original due
                  date in California?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      Even with an automatic extension, failing to pay your
                      taxes by the original due date may result in{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        penalties and interest.
                      </span>{' '}
                      To avoid this, make sure you submit your payment on time —
                      even if you plan to file later.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateCalifornia;
